import { render, staticRenderFns } from "./VendorDeliveryInformation.vue?vue&type=template&id=7564bbe0&scoped=true&"
import script from "./VendorDeliveryInformation.vue?vue&type=script&lang=js&"
export * from "./VendorDeliveryInformation.vue?vue&type=script&lang=js&"
import style0 from "./VendorDeliveryInformation.vue?vue&type=style&index=0&id=7564bbe0&prod&lang=scss&scoped=true&"
import style1 from "./VendorDeliveryInformation.vue?vue&type=style&index=1&id=7564bbe0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7564bbe0",
  null
  
)

export default component.exports